// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kw-0";